import React from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import styles from "./index.module.scss";
import FiltersComponent from "../filters-component";

export default function FilterModel({
  popRef
}: {
  popRef: React.RefObject<OverlayPanel>;
}) {
  return (
    <OverlayPanel ref={popRef} className={styles.FilterModel}>
      <FiltersComponent closeModal={() => popRef?.current?.hide()} />
    </OverlayPanel>
  );
}
